import type { Asset } from 'types/assets'

export const showTextAvatar = (asset: Asset) => {
  return (
    asset.unitName?.toLocaleLowerCase() === 'nfd' &&
    asset.imageUrl.includes('nfd-image-placeholder')
  )
}
